import styled from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

export const StyledMetricIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: ${colorsPalettes.bluegrey[100]};
  & div[data-automation-icon-name='revenue'] svg {
    margin-top: 1.5px;
    margin-left: 1.5px;
  }
`;
